// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"300":"5822e951","856":"72df9735","952":"5ea4174d"}[chunkId] + ".chunk.js";
};